import { t } from '@/i18n';
import { useStore } from '@/state/store';
import { Emoji } from '@/ui';

/** "Bağlantı koptu, yeniden bağlanılıyor…" banner; hidden while connected or idle (and in game). */
export function ConnectionBadge() {
  const connection = useStore((s) => s.connection);
  const connect = useStore((s) => s.connect);
  // In game the header carries its own status badge; this floating banner would sit right on top
  // of the live team totals. Keep it only for the dead-end `offline` state (it has the retry).
  const inGame = useStore((s) => {
    const phase = s.room?.phase;
    return !!phase && phase !== 'lobby' && phase !== 'game-over';
  });
  if (connection === 'connected' || connection === 'idle') return null;
  const offline = connection === 'offline';
  if (inGame && !offline) return null;
  return (
    <div
      role="status"
      data-testid="connection-badge"
      data-connection={connection}
      className={`fixed top-3 left-1/2 z-50 flex -translate-x-1/2 -rotate-1 items-center gap-2 border-3 border-ink px-4 py-1.5 text-[14px] font-extrabold whitespace-nowrap shadow-ink-sm ${offline ? 'bg-team-b text-white' : 'bg-yellow'}`}
    >
      <Emoji emoji={offline ? '🔌' : '📡'} label="" size={18} />
      {t(`connection.${connection}`)}
      {offline ? (
        <button
          type="button"
          className="ml-1 underline decoration-2 underline-offset-2"
          onClick={connect}
        >
          {t('connection.retry')}
        </button>
      ) : null}
    </div>
  );
}
